import { useState, type ReactNode } from 'react';
import { useId } from 'react-aria';
import { Minus, Plus } from '@hungryroot/icons';
import { TransparentButton, Paragraph } from '@hungryroot/ramen';

import styles from './Accordion.module.css';

interface Props {
  title: string;
  children: ReactNode;
  className?: string;
}

export function Accordion({ title, children, className }: Props) {
  const id = useId();
  const sectionId = useId();
  const [expanded, setExpanded] = useState(false);
  const icon = expanded === true ? <Minus /> : <Plus />;

  return (
    <div className={className}>
      <header id={id}>
        <Paragraph variant="caption">
          <TransparentButton
            className={styles.row}
            ariaControls={sectionId}
            ariaExpanded={expanded === true}
            onClick={(e) => {
              e.preventDefault();
              setExpanded(!expanded);
            }}
          >
            {icon}
            {title}
          </TransparentButton>
        </Paragraph>
      </header>
      {expanded === true && (
        <div className={styles.body} id={sectionId} aria-labelledby={id}>
          {children}
        </div>
      )}
    </div>
  );
}
